import React from 'react'
import { Block, Timeline } from '@components'

const DatoCmsTimeline = ({ paddingTop, paddingBottom, ...props }) => {
  return (
    <Block gutters paddingTop={paddingTop} paddingBottom={paddingBottom}>
      <Timeline {...props} />
    </Block>
  )
}

export default DatoCmsTimeline
